import styled from 'theme';

export const EndpointsWrapper = styled.div``;
